const languageMapping = {
  Auto: undefined, // TODO Use special value instead of undefined
  Afrikaans: 'af',
  Arabic: 'ar',
  Armenian: 'hy',
  Azerbaijani: 'az',
  Belarusian: 'be',
  Bosnian: 'bs',
  Bulgarian: 'bg',
  Catalan: 'ca',
  Chinese: 'zh',
  Croatian: 'hr',
  Czech: 'cs',
  Danish: 'da',
  Dutch: 'nl',
  English: 'en',
  Estonian: 'et',
  Finnish: 'fi',
  French: 'fr',
  Galician: 'gl',
  German: 'de',
  Greek: 'el',
  Hebrew: 'he',
  Hindi: 'hi',
  Hungarian: 'hu',
  Icelandic: 'is',
  Indonesian: 'id',
  Italian: 'it',
  Japanese: 'ja',
  Kannada: 'kn',
  Kazakh: 'kk',
  Korean: 'ko',
  Latvian: 'lv',
  Lithuanian: 'lt',
  Macedonian: 'mk',
  Malay: 'ms',
  Marathi: 'mr',
  Maori: 'mi',
  Nepali: 'ne',
  Norwegian: 'no',
  Persian: 'fa',
  Polish: 'pl',
  Portuguese: 'pt',
  Romanian: 'ro',
  Russian: 'ru',
  Serbian: 'sr',
  Slovak: 'sk',
  Slovenian: 'sl',
  Spanish: 'es',
  Swahili: 'sw',
  Swedish: 'sv',
  Tagalog: 'tl',
  Tamil: 'ta',
  Thai: 'th',
  Turkish: 'tr',
  Ukrainian: 'uk',
  Urdu: 'ur',
  Vietnamese: 'vi',
  Welsh: 'cy',
} as const;

// Reverse the languageMapping object
const reversedLanguageMapping = Object.entries(languageMapping).reduce(
  (acc, [key, value]) => {
    if (value !== undefined) {
      acc[value] = key;
    }
    return acc;
  },
  {} as Record<string, string>
);

// Function to get language name by code
export const getLanguageName = (code: string): string => {
  return reversedLanguageMapping[code];
};

type LanguageNameType = keyof typeof languageMapping;
export type LanguageCodeType = typeof languageMapping[LanguageNameType];
type LanguageType = { label: LanguageNameType; value: LanguageCodeType };

const topLanguages: LanguageType[] = [
  { label: 'Auto', value: undefined },
  { label: 'English', value: languageMapping.English },
  { label: 'Spanish', value: languageMapping.Spanish },
  { label: 'French', value: languageMapping.French },
  { label: 'German', value: languageMapping.German },
  { label: 'Japanese', value: languageMapping.Japanese },
  { label: 'Portuguese', value: languageMapping.Portuguese },
  { label: 'Italian', value: languageMapping.Italian },
  { label: 'Dutch', value: languageMapping.Dutch },
];

const allLanguages: LanguageType[] = Object.keys(languageMapping)
  .sort()
  .map((label) => ({
    label: label as LanguageNameType,
    value: languageMapping[label as LanguageNameType],
  }));

const supportedLanguages: LanguageType[] = [...topLanguages, ...allLanguages];

export default supportedLanguages;
